import axios, { AxiosProgressEvent, CancelToken } from 'axios';

export const commonAPIs = {
  uploadImageToS3: (
    url: string,
    formData: any,
    callback: (progressEvent: AxiosProgressEvent) => void,
    cancelToken?: CancelToken
  ) =>
    axios.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      onUploadProgress: callback,
      cancelToken
    })
};
